import { Article } from "./article";
import { PricingItem } from "./pricing-item";
import { EnumOptionGranularity } from "../../enum/enum.option-granularity";

// Option transformée en pricingItem (type OPTION).
// N'étend volontairement pas DevicePricingItem ; garde son propre champ option
// pour réutiliser l'affichage du prix appliqué et du corridor article ; exclue du
// getter QuoteService.productPricingItems (voir quote-service.ts).
// Le code identifiant l'option est option.codeElis (pas de champ optionCode dédié).
// granularity : SERVICE = ajoutée via la popin (éditable/supprimable),
// ARTICLE = dérivée des options cochées sur les lignes articles (quantité = somme des
// quantités des articles porteurs, synchronisée par quote.effects.ts).
export class OptionPricingItem extends PricingItem {
    public readonly option?: Article;
    public readonly granularity?: EnumOptionGranularity;
    public readonly precalculatedQuantity?: string;

    get isArticleOption(): boolean {
        return this.granularity === EnumOptionGranularity.ARTICLE;
    }
}
